import styled from "styled-components";
import { theme } from "../../../styles/theme";

export const Container = styled.div`
  padding: 1.25rem;
  min-width: 20.625rem;
  max-width: 20.625rem;
  min-height: 20.625rem;
  max-height: 20.625rem;
  
  display: flex;
  align-items: center;
  justify-content: center;
  
  border-radius: 1rem;
  background-color: #ffff;
  border: 0.125rem solid ${theme.colors.gray.Cinza_13};
  
  @media (max-width: 1320px) {
    width: 100%;
    max-width: 100%;
  }

  @media (max-width: 1000px) {
    min-width: auto;
  }

  @media (max-width: 768px) {
    width: 100% !important;
    max-width: 100% !important;
  }
`;

export const Wrapper = styled.div`
    gap: 1.25rem;
    display: flex;
    text-align: center;
    align-items: center;
    flex-direction: column;
    justify-content: center;
`;

export const Image = styled.img`
  height: 5.5rem;
  width: 9.542rem;
`;

export const Button = styled.button`
  padding: 0.75rem 2rem;
  
  display: flex;
  align-items: center;
  justify-content: center;
  
  cursor: pointer;
  border-radius: 1.563rem;
  border: 1px solid ${theme.colors.gray.Cinza_2};
  background-color: ${theme.colors.white.Branco};
  transition: background-color 0.3s ease;
  
  >p{
    cursor: pointer;
  }

  &:hover {
    background-color: #f5f5f5;
  }
`;

export const Icon = styled.img`
  width: 1.25rem;
  height: 1.25rem;
  
  margin-right: 0.625rem;
`;